// ══════════════════════════════════════════════════════
//  extractors/holders.js — 持有者集中度
//
//  源：Surf /token/holders → project.topHolders
// ══════════════════════════════════════════════════════

import { safeNum } from './_shared';

export function isAvailable(project) {
  return !!project?.topHolders?.holders?.length;
}

export function extract(project /* , a */) {
  const th = project?.topHolders;
  if (!th?.holders?.length) return null;

  const holders = th.holders.map(h => ({
    address: h?.address || null,
    label:   h?.entityName || h?.entityType || null,
    percent: safeNum(h?.percentage),  // 0~100 比例
  })).filter(h => h.percent != null);

  const top10Concentration = safeNum(th.top10Concentration);
  const top1Pct = holders[0]?.percent ?? null;
  const top5Pct = holders.slice(0, 5).reduce((s, h) => s + (h.percent || 0), 0);

  return {
    holders,
    chain: th.chain || null,
    top1Pct, top5Pct,
    top10Concentration,  // 0~100 范围
  };
}
